import { TwoTermsAssignmentCtrl } from './two-terms-assignment.controller';

export const TwoTermsAssignment = {
  controller: TwoTermsAssignmentCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./two-terms-assignment.html'),
};
